import React, { useState } from "react";
import axios from "axios";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Tooltip,
  OverlayTrigger,
  Form,
} from "react-bootstrap";

import useAuth from "../../customHooks/useAuth";
import StyledLink from "../general/StyledLink";
import { planes } from "../general/pagos/config";

const Planes = () => {
  const [codigo, setCodigo] = useState("");
  const [promo, setPromo] = useState(null);
  const [codigoValido, setCodigoValido] = useState(false);

  const { isAuth, logout, externalReference } = useAuth();

  const handleChange = (e) => {
    setCodigo(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await axios.post("/api/validarCodigo", { codigo });
      if (data) {
        setPromo(data.promo);
        setCodigoValido(true);
      } else {
        setCodigoValido(false);
      }
    } catch (error) {
      console.error("Error al validar el código:", error);
      setCodigoValido(false);
    }
  };

  const tooltip = (
    <Tooltip placement="top" id="tooltip-top">
      {isAuth
        ? "Subscripción temporalmente deshabilitada, porfavor regresa pronto"
        : "Inicia sesión para poder crear tu suscripción"}
    </Tooltip>
  );

  return (
    <div id="watermark">
      <Container className="text-center" id="planes">
        <Row>
          {Object.entries(planes).map(([slug, plan]) => {
            const {
              titulo,
              precio,
              periodo,
              renueva,
              link_pago,
              should_have_external_reference,
            } = plan;

            return (
              <Col key={slug} lg={4}>
                <a
                  href={
                    isAuth
                      ? link_pago +
                        (should_have_external_reference
                          ? "&external_reference=" + externalReference
                          : "")
                      : undefined
                  }
                  style={{
                    color: "inherit",
                    textDecoration: "none",
                    cursor: isAuth ? "pointer" : "default",
                  }}
                >
                  <OverlayTrigger
                    placement="top"
                    overlay={isAuth ? <></> : tooltip}
                  >
                    <Card>
                      <Card.Body className="no-linkdev-style">
                        <Card.Title>{titulo}</Card.Title>
                        <Card.Subtitle className="precio">
                          $ {precio} COP
                        </Card.Subtitle>
                        <Card.Text>{periodo}</Card.Text>
                        <Card.Text className="descripcion-plan">
                          Al empezar tu suscripción obtendrás acceso a todas las
                          características de la plataforma, incluyendo un amplio
                          repertorio médico, un proceso sencillo para obtener tu
                          repertorización y la opción de gestionar las consultas
                          de tus pacientes.
                        </Card.Text>
                        <Button
                          variant="default"
                          className="btn-get-started"
                          disabled={!isAuth}
                        >
                          Suscribirme
                        </Button>
                        <Card.Text className="text-muted footer">
                          El plan se renueva {renueva}
                        </Card.Text>
                      </Card.Body>
                    </Card>
                  </OverlayTrigger>
                </a>
              </Col>
            );
          })}
        </Row>

        <Row className="mt-4">
          <Col>
            <p>
              ¿Tienes un código de descuento? Ingresa tu código a continuación:
            </p>
          </Col>
          <Col>
            <Form onSubmit={handleSubmit}>
              <Form.Group controlId="codigoDescuento">
                <Form.Control
                  disabled={!isAuth}
                  onChange={handleChange}
                  placeholder="Ingresa el código de descuento"
                  value={codigo}
                />
              </Form.Group>
            </Form>
          </Col>
        </Row>

        {codigoValido && (
          <Row className="mt-3">
            <p>
              El descuento ha sido aplicado correctamente. Haz clic en el
              siguiente botón para continuar.
            </p>
            {promo === "activa" ? (
              <StyledLink to="/">
                <Button variant="success" onClick={logout}>
                  Continuar
                </Button>
              </StyledLink>
            ) : (
              <StyledLink to="/pago">
                <Button variant="success">Continuar</Button>
              </StyledLink>
            )}
          </Row>
        )}

        <Row className="mt-4">
          <Col>
            <p>
              Al adquirir tu suscripción en Aurea, accederás a un amplio
              catálogo médico con toda la información necesaria para gestionar y
              organizar tu consultorio homeopático. Aplican{" "}
              <StyledLink to="tyc">términos y condiciones</StyledLink>.
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Planes;
